// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__PKcSv","location":"Header_location__3guP-"};